import React from 'react';

const ActivityFeedStatus = ({ status, url, i18n }) => {
  const Highlight = ({ children }) => (
    <a href={url} className="ActivityFeedItem-status">
      {children}
    </a>
  );

  switch (status.name) {
    case 'started':
      return (
        <span>
          <Highlight>{i18n.started}</Highlight> {i18n.assignment}
        </span>
      );
    case 'overdue':
      return (
        <span>
          {i18n.is_now} <Highlight>{i18n.overdue}</Highlight> {i18n.status_on}{' '}
          {i18n.assignment}
        </span>
      );
    case 'grade_pending':
      return (
        <span>
          {i18n.is_now} <Highlight>{i18n.grade_pending}</Highlight>{' '}
          {i18n.status_on} {i18n.assignment}
        </span>
      );
    case 'completed':
      return (
        <span>
          <Highlight>{i18n.completed}</Highlight> {i18n.assignment}
        </span>
      );
    case 'scored':
      return (
        <span>
          <Highlight>
            {i18n.scored} {status.value}
          </Highlight>{' '}
          {i18n.status_on} {i18n.assignment}
        </span>
      );
    default:
      return false;
  }
};

export default ActivityFeedStatus;
